import React from 'react'
import styles from '../styles/InfoIcon.module.css'

function InfoIcon() {


    return (
        <div className={styles.infoIconContainer}>
            <p className={styles.infoIconI}>i</p>
        </div>
    )
}

export default InfoIcon;